<template>
  <nav class="admin-navigation">
    <ul v-if="getCurrentUser">
      <li>
        <span v-if="isAdmin">Admin</span>
        <span v-else>Agent</span>: 
      </li>
      <li>
        <router-link :to="`/${$i18n.locale}/admin/bookings`" title="Bookings">
          <i class="fal fa-calendar"></i>
          <span>Bookings</span>
        </router-link>
      </li>
      <li>
        <router-link :to="`/${$i18n.locale}/admin/account`" title="My Account">
          <i class="fal fa-user"></i>
          <span>My Account</span>
        </router-link>
      </li>
      <li class="logout">
        <a class="" href="#" @click="logout()" title="Logout">
          <i class="fal fa-sign-out"></i>
        </a>
      </li>
    </ul>
  </nav>
</template>

<script>
import {auth} from '@/firebaseConfig';
import {mapGetters} from 'vuex';
export default {
  name: 'AdminNavigation',

  data () {
    return {
    }
  },


  computed: {
    ...mapGetters([
      'getCurrentUser',
    ]),
    isAdmin() {
      let self = this;
      if (self.getCurrentUser) {
        return self.getCurrentUser.claims && (['su', 'admin'].includes(self.getCurrentUser.claims.role));
      }

      return false;
    }
  },

  methods: {
    logout: function() {
      let self = this;
      self.$store.dispatch('setCurrentUser', null);
      auth.signOut().then(() => {
        self.$router.push(`/${self.$i18n.locale}/admin/login`)
      })
    }
  }
}
</script>